import { AnalyticsStore, updateSearch } from 'bernie-core';

import { SearchResultsStore } from 'stores/search-results-store';

import { History, Location } from 'history';
import { LodgingPwaPropertySearch } from '__generated__/api';

import Analytics = LodgingPwaPropertySearch.Analytics;

type LinkAction = {
  analytics: Analytics;
  resource: {
    relativePath: string;
  };
};

const isALinkAction = (action: any): boolean => action?.analytics && action.resource?.relativePath;

export const handleLinkActionFromErrorMessage = (
  action: unknown,
  analytics: AnalyticsStore,
  searchResults: SearchResultsStore,
  history: History,
  location: Location
) => {
  if (isALinkAction(action)) {
    const linkAction = action as LinkAction;
    const { referrerId } = linkAction.analytics;
    const message = 'MultiItem Error';
    const hotelsSearchURL = linkAction.resource.relativePath;

    if (analytics && typeof analytics.trackEvent === 'function') {
      analytics.trackEvent(referrerId, message, null, null, true);
    }

    window.location.replace(hotelsSearchURL);
  } else {
    handleRetry(':errorOnSearch', 'MultiItem Retry Search', analytics, searchResults, history, location);
  }
};

export const handleRetry = (
  rfrr: string,
  message: string,
  analytics: AnalyticsStore,
  searchResults: SearchResultsStore,
  history: History,
  location: Location
) => {
  if (analytics && typeof analytics.trackEvent === 'function') {
    analytics.trackEvent(rfrr, message, null, null, true);
  }

  searchResults.shouldFetch = true;
  updateSearch({ history, location, newParams: {} });
};
